import {
    DELETE_PRODUCT,
    DELETE_PRODUCT_FAILURE,
    DELETE_PRODUCT_SUCCESS,

    DELETE_PRODUCT_LOGO,
    DELETE_PRODUCT_LOGO_FAILURE,
    DELETE_PRODUCT_LOGO_SUCCESS,
} from 'store/actions/types';

export const deleteProduct = (payload) => {
    return {
        type: DELETE_PRODUCT,
        payload: payload,
    };
};

export const deleteProductFailure = (error) => {
    return {
        type: DELETE_PRODUCT_FAILURE,
        error: error,
    };
};

export const deleteProductSuccess = (payload) => {
    return {
        type: DELETE_PRODUCT_SUCCESS,
        payload: payload,
    };
};

export const deleteProductLogo = (payload) => {
    return {
        type: DELETE_PRODUCT_LOGO,
        payload: payload,
    };
};

export const deleteProductLogoFailure = () => {
    return {
        type: DELETE_PRODUCT_LOGO_FAILURE,
    };
};

export const deleteProductLogoSuccess = (payload) => {
    return {
        type: DELETE_PRODUCT_LOGO_SUCCESS,
        id: payload.id,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/products/deleteProducts.js